import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { dialogStyles } from "../../Constants/dialogStyles";
import { Close } from "@mui/icons-material";
import theme from "../../Constants/theme";
import {
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../Constants/buttonStyles";

export const StarterLimitationsDialog = ({
  openKeysPopup,
  setOpenKeysPopup,
  setCanStartTour,
  setTabName,
  navigate,
}) => {
  return (
    <Dialog
      open={openKeysPopup}
      onClose={() => {
        setOpenKeysPopup(false);
        setCanStartTour(true);
      }}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
      fullWidth
    >
      <DialogTitle sx={dialogStyles.dialogTitle}>
        <Typography sx={dialogStyles.dialogTitleText}>
          API Keys Required
        </Typography>
        <IconButton
          sx={dialogStyles.dialogCloseIcon}
          onClick={() => {
            setOpenKeysPopup(false);
            setCanStartTour(true);
          }}
          size="small"
          aria-label="close"
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ ...dialogStyles.dialogContent, mt: 2 }}>
        <DialogContentText sx={dialogStyles.dialogContentText}>
          To extend usage limits, please provide your OpenAI and Pinecone API
          keys. Without these keys, the following restrictions will apply:
        </DialogContentText>
        <Typography variant="body2" sx={{ fontWeight: 500, mt: 1 }}>
          Free Tier Limitations:
        </Typography>
        <List dense sx={{ pl: 2 }}>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: "24px" }}>
              <Typography
                variant="body2"
                sx={{ color: theme.textColors.dark.primary }}
              >
                -
              </Typography>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="body2">
                  Up to 5 datasets with a combined size limit of 5MB
                </Typography>
              }
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: "24px" }}>
              <Typography
                variant="body2"
                sx={{ color: theme.textColors.dark.primary }}
              >
                -
              </Typography>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="body2">
                  Maximum of 5 combination runs
                </Typography>
              }
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: "24px" }}>
              <Typography
                variant="body2"
                sx={{ color: theme.textColors.dark.primary }}
              >
                -
              </Typography>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="body2">
                  Limit of 5 golden responses
                </Typography>
              }
            />
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon sx={{ minWidth: "24px" }}>
              <Typography
                variant="body2"
                sx={{ color: theme.textColors.dark.primary }}
              >
                -
              </Typography>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="body2">
                  Only 1 URL can be crawled (nested links will not be followed)
                </Typography>
              }
            />
          </ListItem>
        </List>
        <Typography variant="body2">
          Note: Providing API keys allows increased limits but does not grant
          full access to premium features.
        </Typography>
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button
          onClick={() => setOpenKeysPopup(false)}
          sx={secondaryButtonStyles}
        >
          Continue with limitations
        </Button>
        <Button
          onClick={() => {
            setOpenKeysPopup(false);
            setTabName("settingsPage");
            navigate("/dashboard/settingsPage");
          }}
          sx={primaryButtonStyles}
        >
          Add keys
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const PaymentSuccessDialog = ({
  setShowPaymentSuccess,
  showPaymentSuccess,
}) => {
  return (
    <Dialog
      open={showPaymentSuccess}
      onClose={() => setShowPaymentSuccess(false)}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
      fullWidth
    >
      <DialogTitle sx={{ ...dialogStyles.dialogTitle, m: 1 }}>
        You have successfully completed the payment.
      </DialogTitle>
      <DialogContent sx={dialogStyles.dialogContent}>
        <DialogContentText sx={{ ...dialogStyles.dialogContentText, mt: 2 }}>
          Please contact on <b>support@queryloop.ai</b> for any assistance.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button
          onClick={() => setShowPaymentSuccess(false)}
          sx={primaryButtonStyles}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
